import { connect } from 'react-redux';
import { selectSocialLinks } from "../../store/selectors";
import { selectShortFooterLayout } from "../../store/slices/layout/selectors";
var mapStateToProps = function mapStateToProps(state) {
  var socialsLinks = selectSocialLinks(state);
  var theme = selectShortFooterLayout(state);
  return {
    socialsLinks: socialsLinks || [],
    theme: theme
  };
};
export var connector = connect(mapStateToProps);